module.exports = "/static/assets/6b4c7434da0f872e47f75f8b90b1c81d.png";